import React, { Component } from "react";
import styled from "styled-components";
import { PropTypes } from "prop-types";
import SweetAlert from "react-bootstrap-sweetalert";
import { withRouter } from "react-router-dom";
import {
  Button,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  UncontrolledDropdown,
  Badge,
  Table,
} from "reactstrap";
import DynamicModalWithInput from "../../../../../components/DynamicModalWithInput/DynamicModalWithInput";
import AddAppModal from "./common/AddAppModal";
import AddSiteModal from "./common/AddSiteModal";
import RemoteTable from '../../../../../components/Common/RemoteTable';

class Applications extends Component {
  constructor(props) {
    super(props);

    this.state = {
      apps: null,
      deleteModalActive: false,
      deleteAppData: null,
      viewAddApp: false,
      viewAddAppSite: false,
      editData: null,
    };
  }

  componentDidMount() {
    this.setState({
      apps: this.props.apps.results,
    });
  }

  componentWillUnmount() {
    this.setState({ apps: null });
  }

  componentDidUpdate() {
    if (this.state.apps && this.state.apps.length === 0) {
      this.setState({ apps: null });
    }
  }

  handleChangeDeleteAlert = data => {
    this.setState({ deleteAlert: data });
  };

  onActiveDeleteModal = (name, id, clientId) => {
    const { deleteModalActive } = this.state;
    this.setState({
      deleteModalActive: !deleteModalActive,
      deleteAppData: {
        name,
        id,
        clientId,
      },
    });
  };

  onDelete = () => {
    const { deleteModalActive, deleteAppData } = this.state;
    this.props.deleteApp(deleteAppData.id, deleteAppData.clientId);
    this.setState({
      deleteModalActive: !deleteModalActive,
      deleteAppData: null,
    });
  };

  toggleViewAddAppModal = () => {
    this.setState(prevState => ({
      viewAddApp: !prevState.viewAddApp,
      editData: null,
    }));
  };

  toggleViewAddAppSiteModal = () => {
    this.setState(prevState => ({
      viewAddAppSite: !prevState.viewAddAppSite,
      editData: null,
    }));
  };

  render() {
    const { apps } = this.props;
    const backgroundsColors = ["primary", "success", "danger"];
    const client_id = this.props.match.params.clientId;

    const onClickRow = (e, row) => {
      this.props.history.push(`/service-providers/${row.id}`);
    };

    const nameFormatter = (cell, row, label) => {
      return (
        <NameLink onClick={e => onClickRow(e, row)}>{row[label]}</NameLink>
      );
    };

    const columns = [
      {
        dataField: "app_picture",
        text: "Image",
        sort: true,
        formatter: (cell, row) => {
          return (<div onClick={
            row.type == 1
              ? () => onClickEditApp(row)
              : () => onClickEditAppSite(row)
          }>
            {row.app_picture !== null ? (
              <ImageStyled
                src={row.app_picture}
                alt=""
                className="avatar-sm"
              />
            ) : (
              <AvatarStyled
                className={`bg-${backgroundsColors[
                  Math.floor(
                    Math.random() * backgroundsColors.length
                  )
                ]
                  } `}
              >
                <span
                  style={{
                    position: "relative",
                    fontWeight: "bold",
                    fontSize: "25px",
                    color: "white",
                    left: "14px",
                    top: "4px",
                  }}
                >
                  {row.name[0]}
                </span>
              </AvatarStyled>
            )}
          </div>)
        },
      },
      {
        dataField: "name",
        text: "App",
        sort: true,
        formatter: (cell, row) => {
          return <StyleLink onClick={
            row.type == 1
              ? () => onClickEditApp(row)
              : () => onClickEditAppSite(row)
          }>
            <h5 className="text-truncate font-size-14 name--app">
              {row.name}
            </h5>
            <p className="text-muted mb-0">
              Client: {row.client.legal_name}{" "}
            </p>
          </StyleLink>
        },
      },
      {
        dataField: "created_at",
        text: "Created",
        sort: true,
        formatter: (cell, row) => dateFormatter(row.created_at),
      },
      {
        dataField: "display_type",
        text: "Type",
        sort: true,
        formatter: (cell, row) => {
          return <>
            <Badge className={"bg-info"}>
              {row.display_type}
            </Badge>
          </>
        },
      },
      {
        dataField: "display_os_type",
        text: "OS",
        sort: true,
        formatter: (cell, row) => {
          return <div>
            <Badge className={"bg-primary"}>
              {row.display_type == "SITE"
                ? ""
                : row.display_os_type}
            </Badge>
          </div>
        },
      },
      {
        dataField: "status",
        text: "Status",
        sort: false,
        formatter: (cell, row) => {
          return <>
            <Badge
              className={`bg-${row.is_active ? "success" : "warning"
                }`}
            >
              {row.is_active ? "Active" : "Not active"}
            </Badge>
          </>
        },
      },
      {
        dataField: "actions",
        text: "Rent",
        sort: false,
        formatter: (cell, row) => {
          return <>
            <Badge
              className={`bg-${row.is_rent ? "info" : "secondary"
                }`}
            >
              {row.is_rent ? "Rent" : "Not rent"}
            </Badge>
          </>
        },
      },
      {
        dataField: "actions",
        text: "Actions",
        sort: false,
        formatter: (cell, row) => {
          return <>
            {(this.props.permissions[
              "delete_clientapplicationmodel"
            ] ||
              this.props.permissions[
              "change_clientapplicationmodel"
              ]) && (
                <UncontrolledDropdown>
                  <DropdownToggle className="card-drop" tag="a">
                    <i className="mdi mdi-dots-horizontal font-size-18" />
                  </DropdownToggle>
                  <DropdownMenu className="dropdown-menu-end">
                    {this.props.permissions[
                      "change_clientapplicationmodel"
                    ] && (
                        <DropdownItem
                          onClick={
                            row.type == 1
                              ? () => onClickEditApp(row)
                              : () => onClickEditAppSite(row)
                          }
                        >
                          <i className="mdi mdi-pencil font-size-16 text-success me-1 align-middle" />{" "}
                          Edit
                        </DropdownItem>
                      )}
                    {this.props.permissions[
                      "delete_clientapplicationmodel"
                    ] && (
                        <DropdownItem
                          onClick={() =>
                            this.onActiveDeleteModal(
                              row.name,
                              row.id,
                              row.client.id
                            )
                          }
                        >
                          <i className="mdi mdi-trash-can font-size-16 text-danger me-1 align-middle" />{" "}
                          Delete
                        </DropdownItem>
                      )}
                  </DropdownMenu>
                </UncontrolledDropdown>
              )}
          </>
        },
      },
    ];

    const onClickApp = (e, row, type) => {
      if (this.props.permissions?.["view_campaignsourcemodel"]) {
        this.setState(prevState => ({
          viewAddApp: !prevState.viewAddApp,
          editData: type === "edit" ? row : null,
        }));
      }
    };

    const onClickAppSite = (e, row, type) => {
      if (this.props.permissions?.["view_campaignsourcemodel"]) {
        this.setState(prevState => ({
          viewAddAppSite: !prevState.viewAddAppSite,
          editData: type === "edit" ? row : null,
        }));
      }
    };

    const onClickAddAppSite = () => {
      onClickAppSite("", {}, "");
    };

    const onClickAddApp = () => {
      onClickApp("", {}, "");
    };

    const onClickEditAppSite = data => {
      onClickAppSite("", data, "edit");
    };

    const onClickEditApp = data => {
      onClickApp("", data, "edit");
    };

    const dateFormatter = date => {
      let data = new Date(date).toLocaleString();
      return data;
    };

    const handleTableChange = data => {
      this.props.getAppsById(client_id, {
        ...data,
        size: data.sizePerPage,
      })
    }

    return (
      <React.Fragment>
        {this.state.viewAddAppSite && (
          <AddSiteModal
            toggle={this.toggleViewAddAppSiteModal}
            isOpen={this.state.viewAddAppSite}
            patchAppStatus={this.props.patchAppStatus}
            client_id={client_id}
            patchApp={this.props.patchApp}
            setApp={this.props.setApp}
            setAppDataNull={this.props.setAppDataNull}
            addAppById={this.props.addAppById}
            editData={this.state.editData}
            permissions={this.props.permissions}
          />
        )}

        {this.state.viewAddApp && (
          <AddAppModal
            toggle={this.toggleViewAddAppModal}
            isOpen={this.state.viewAddApp}
            tracking_platforms={this.props.tracking_platforms}
            patchAppStatus={this.props.patchAppStatus}
            client_id={client_id}
            patchApp={this.props.patchApp}
            setApp={this.props.setApp}
            setAppDataNull={this.props.setAppDataNull}
            addAppById={this.props.addAppById}
            editData={this.state.editData}
            permissions={this.props.permissions}
          />
        )}

        <DynamicModalWithInput
          isOpen={this.state.deleteModalActive}
          toggle={this.onActiveDeleteModal}
          action={this.onDelete}
          header={this.state.deleteAppData?.name}
          what="delete"
          alertColor="danger"
          alertText="Deleting a offer permanently removes the offer content. The
              profile, trackers, media buyer budgets, media buyer plans and
              offer history."
        />
        {this.state.deleteAlert && (
          <SweetAlert
            showCancel
            confirmBtnText="Delete"
            cancelBtnText="Cancel"
            confirmBtnBsStyle="danger"
            title="Delete application"
            onCancel={() =>
              this.setState({
                deleteAlert: !this.state.deleteAlert,
              })
            }
            onConfirm={this.state.deleteAlertData.onConfirm}
          >
            <p>
              Are you sure want to delete {this.state.deleteAlertData.name_app}?
            </p>
          </SweetAlert>
        )}
        <Application>
          <Col md={12}>
            <div>
              <Row>
                <Col sm="4">
                  <h4 style={{ marginTop: "6px" }}>Applications</h4>
                </Col>
                <Col sm="8">
                  <div className="text-sm-end">
                    {this.props.permissions["add_clientapplicationmodel"] && (
                      <>
                        <Button
                          type="button"
                          color="primary"
                          className="btn-rounded mb-2 me-2"
                          onClick={onClickAddAppSite}
                        >
                          <i className="mdi mdi-plus me-1" /> New website
                        </Button>
                        <Button
                          type="button"
                          color="success"
                          className="btn-rounded mb-2"
                          onClick={onClickAddApp}
                        >
                          <i className="mdi mdi-plus me-1" /> New application
                        </Button>
                      </>
                    )}
                  </div>
                </Col>
              </Row>
              {apps.results.length != 0 ? (
                <Row className="mt-3">
                  <RemoteTable
                    onTableChange={handleTableChange}
                    columns={columns}
                    data={apps}
                    loading={this.props.apps_loading}
                    search_input={false}
                    disable_pages={apps.count <= 10}
                  />
                  {/* <Table className="table project-list-table table-nowrap align-middle table-borderless">
                    <thead>
                      <tr>
                        <th scope="col" style={{ width: "100px" }}>
                          Image
                        </th>
                        <th scope="col">App</th>
                        <th scope="col">Created</th>
                        <th scope="col">Type</th>
                        <th scope="col">OS</th>
                        <th scope="col">Status</th>
                        <th scope="col">Rent</th>
                        {(this.props.permissions[
                          "delete_clientapplicationmodel"
                        ] ||
                          this.props.permissions[
                            "change_clientapplicationmodel"
                          ]) && <th scope="col">Action</th>}
                      </tr>
                    </thead>
                    {apps.results.length != 0 &&
                      apps.results.map((i, key) => (
                        <tbody key={key}>
                          <StyledTR>
                            <td
                              onClick={
                                i.type == 1
                                  ? () => onClickEditApp(i)
                                  : () => onClickEditAppSite(i)
                              }
                            >
                              {i.app_picture !== null ? (
                                <ImageStyled
                                  src={i.app_picture}
                                  alt=""
                                  className="avatar-sm"
                                />
                              ) : (
                                <AvatarStyled
                                  className={`bg-${
                                    backgroundsColors[
                                      Math.floor(
                                        Math.random() * backgroundsColors.length
                                      )
                                    ]
                                  } `}
                                >
                                  <span
                                    style={{
                                      position: "relative",
                                      fontWeight: "bold",
                                      fontSize: "25px",
                                      color: "white",
                                      left: "14px",
                                      top: "4px",
                                    }}
                                  >
                                    {i.name[0]}
                                  </span>
                                </AvatarStyled>
                              )}
                            </td>
                            <td
                              onClick={
                                i.type == 1
                                  ? () => onClickEditApp(i)
                                  : () => onClickEditAppSite(i)
                              }
                            >
                              <h5 className="text-truncate font-size-14 name--app">
                                {i.name}
                              </h5>
                              <p className="text-muted mb-0">
                                Client: {i.client.legal_name}{" "}
                              </p>
                            </td>
                            <td style={{ cursor: "default" }}>
                              {dateFormatter(i.created_at)}
                            </td>
                            <td style={{ cursor: "default" }}>
                              <Badge className={"bg-info"}>
                                {i.display_type}
                              </Badge>
                            </td>
                            <td style={{ cursor: "default" }}>
                              <Badge className={"bg-primary"}>
                                {i.display_type == "SITE"
                                  ? ""
                                  : i.display_os_type}
                              </Badge>
                            </td>
                            <td style={{ cursor: "default" }}>
                              <Badge
                                className={`bg-${
                                  i.is_active ? "success" : "warning"
                                }`}
                              >
                                {i.is_active ? "Active" : "Not active"}
                              </Badge>
                            </td>
                            <td style={{ cursor: "default" }}>
                              <Badge
                                className={`bg-${
                                  i.is_rent ? "info" : "secondary"
                                }`}
                              >
                                {i.is_rent ? "Rent" : "Not rent"}
                              </Badge>
                            </td>
                            <td>
                              {(this.props.permissions[
                                "delete_clientapplicationmodel"
                              ] ||
                                this.props.permissions[
                                  "change_clientapplicationmodel"
                                ]) && (
                                <UncontrolledDropdown>
                                  <DropdownToggle className="card-drop" tag="a">
                                    <i className="mdi mdi-dots-horizontal font-size-18" />
                                  </DropdownToggle>
                                  <DropdownMenu className="dropdown-menu-end">
                                    {this.props.permissions[
                                      "change_clientapplicationmodel"
                                    ] && (
                                      <DropdownItem
                                        onClick={
                                          i.type == 1
                                            ? () => onClickEditApp(i)
                                            : () => onClickEditAppSite(i)
                                        }
                                      >
                                        <i className="mdi mdi-pencil font-size-16 text-success me-1 align-middle" />{" "}
                                        Edit
                                      </DropdownItem>
                                    )}
                                    {this.props.permissions[
                                      "delete_clientapplicationmodel"
                                    ] && (
                                      <DropdownItem
                                        onClick={() =>
                                          this.onActiveDeleteModal(
                                            i.name,
                                            i.id,
                                            i.client.id
                                          )
                                        }
                                      >
                                        <i className="mdi mdi-trash-can font-size-16 text-danger me-1 align-middle" />{" "}
                                        Delete
                                      </DropdownItem>
                                    )}
                                  </DropdownMenu>
                                </UncontrolledDropdown>
                              )}
                            </td>
                          </StyledTR>
                        </tbody>
                      ))}
                  </Table> */}
                </Row>
              ) : (
                <Row className="align-items-center text-center mt-4">
                  <Col xs={12}>
                    <i
                      className="dripicons-archive"
                      style={{ fontSize: "130px", opacity: "0.2" }}
                    ></i>
                    <p style={{ opacity: "0.2" }}>
                      Oops, client has no offers...
                    </p>
                  </Col>
                </Row>
              )}
            </div>
          </Col>
        </Application>
      </React.Fragment>
    );
  }
}

const NameLink = styled.div`
  transition-duration: 0.1s;
  &:hover {
    color: rgb(85, 110, 230);
    transition-duration: 0.1s;
  }
`;

const StyleLink = styled.div`
  transition: all 3ms linear;
  .name--app {
    transition: all 3ms linear;
    &:hover {
      color: #556ee6;
    }
  }

  &:hover {
    background: #f8f9fa;
  }
`;

const Application = styled.div`
  //padding-top: 15px;
  //margin-top: 15px;
  //box-shadow: 0 0.75rem 1.5rem rgb(18 38 63 / 3%);
`;

const ImageStyled = styled.img`
  border-radius: 50%;
`;

const AvatarStyled = styled.div`
  border-radius: 50%;
  height: 45px;
  width: 45px;
`;

Applications.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      clientId: PropTypes.node,
    }).isRequired,
  }).isRequired,
  apps: PropTypes.any,
  apps_loading: PropTypes.bool.isRequired,
  getAppsById: PropTypes.func.isRequired,
  history: PropTypes.any,
  AddAppToggle: PropTypes.func,
  addApp: PropTypes.func,
  deleteApp: PropTypes.func,
  userId: PropTypes.func,
  tracking_platforms: PropTypes.any,
  permissions: PropTypes.any,
  patchAppStatus: PropTypes.func,
  patchApp: PropTypes.func,
  setApp: PropTypes.func,
  setAppDataNull: PropTypes.func,
  addAppById: PropTypes.func.isRequired,
};

export default withRouter(Applications);
